(function () {
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    document.querySelectorAll('.fm-hero__video').forEach(function (video) { video.pause(); });
  }


  // Keep legacy filter/sidebar toggles scoped to their own collection/search section.
  document.addEventListener('click', function (event) {
    var collectionTrigger = event.target.closest('[data-main-collection-toggle-trigger]');
    if (collectionTrigger) {
      var collectionPanel = document.getElementById(collectionTrigger.getAttribute('aria-controls'));
      if (collectionPanel) {
        var collectionOpen = collectionPanel.classList.toggle('xo-active');
        collectionTrigger.classList.toggle('xo-active', collectionOpen);
        collectionTrigger.setAttribute('aria-expanded', String(collectionOpen));
      }
    }
    var searchTrigger = event.target.closest('[data-main-search-toggle-trigger]');
    if (searchTrigger) {
      var searchPanel = document.getElementById(searchTrigger.getAttribute('aria-controls'));
      if (searchPanel) {
        var searchOpen = searchPanel.classList.toggle('xo-active');
        searchTrigger.classList.toggle('xo-active', searchOpen);
        searchTrigger.setAttribute('aria-expanded', String(searchOpen));
      }
    }
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.fm-nav-group[open]').forEach(function (item) {
      if (!item.contains(event.target)) item.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.fm-nav-group[open],.fm-mobile-menu[open]').forEach(function (item) {
        item.removeAttribute('open');
      });
    }
  });

  var revealItems = Array.prototype.slice.call(document.querySelectorAll('[data-fm-reveal]'));
  if (!reduceMotion && 'IntersectionObserver' in window && revealItems.length) {
    root.classList.add('fm-motion-ready');
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.13, rootMargin: '0px 0px -36px 0px' });

    revealItems.forEach(function (item, index) {
      item.style.setProperty('--fm-stagger', Math.min(index % 7, 5));
      revealObserver.observe(item);
    });
  }

  if (reduceMotion || window.matchMedia('(pointer: coarse)').matches) return;

  document.querySelectorAll('[data-fm-tilt]').forEach(function (card) {
    card.addEventListener('pointermove', function (event) {
      var bounds = card.getBoundingClientRect();
      var x = (event.clientX - bounds.left) / bounds.width - 0.5;
      var y = (event.clientY - bounds.top) / bounds.height - 0.5;
      card.style.setProperty('--fm-tilt-y', (x * 5).toFixed(2) + 'deg');
      card.style.setProperty('--fm-tilt-x', (y * -4).toFixed(2) + 'deg');
    });
    card.addEventListener('pointerleave', function () {
      card.style.setProperty('--fm-tilt-x', '0deg');
      card.style.setProperty('--fm-tilt-y', '0deg');
    });
  });

  var hero = document.querySelector('[data-fm-hero]');
  if (!hero) return;
  hero.addEventListener('pointermove', function (event) {
    var bounds = hero.getBoundingClientRect();
    var x = (event.clientX - bounds.left) / bounds.width - 0.5;
    var y = (event.clientY - bounds.top) / bounds.height - 0.5;
    hero.style.setProperty('--fm-pointer-x', (x * -12).toFixed(1) + 'px');
    hero.style.setProperty('--fm-pointer-y', (y * -9).toFixed(1) + 'px');
  });
  hero.addEventListener('pointerleave', function () {
    hero.style.setProperty('--fm-pointer-x', '0px');
    hero.style.setProperty('--fm-pointer-y', '0px');
  });

  var rafPending = false;
  window.addEventListener('scroll', function () {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      var heroBounds = hero.getBoundingClientRect();
      var offset = Math.min(18, Math.max(-18, heroBounds.top * -0.04));
      hero.style.setProperty('--fm-scroll-shift', offset.toFixed(1) + 'px');
      rafPending = false;
    });
  }, { passive: true });
})();
